const twoDigit = new Intl.NumberFormat("nb-NO", {
  minimumIntegerDigits: 2,
  maximumFractionDigits: 0,
})

export function getMinutesAndSeconds(time: number | string | undefined | null, defaultValue = "00:00") {
  if (!time) return defaultValue

  if (typeof time === "string") {
    const parsedTime = parseFloat(time)
    if (isNaN(parsedTime)) {
      return defaultValue
    }
    time = parsedTime
  }
  const minutes = Math.floor(time / 60)
  const seconds = Math.floor(time % 60)
  return [minutes, seconds].map(twoDigit.format).join(":")
}
